import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class Routing {
  private router = inject(Router);

  /** Navigates to the 404 not-found page. */
  goToNotFound(): void {
    this.router.navigate(['/404']);
  }
}
